define('controllers/questionnaire/questionnaire.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('QuestionnaireController', ['$q', '$scope', '$state', 'auiUpload', 'auiDialog', 'OpenUp',
        function ($q, $scope, $state, auiUpload, auiDialog, OpenUp) {
	    			var Model =  $scope.Model = {
	    					gridColumns : [{
	    	    	    		columnField:'关联人员姓名',
	    	    	    		columnKey:'relatedMemName',
	    	    	    		placeholder:'',
	    	    	    		valid:{
	    	    	    			maxLength:64,
	    	    	    			required:{
	    	    	    				value:true,
	    	    	    				tipMsg:""
	    	    	    			}
	    	    	    		},
	    	    	    		columnWidth:'20%'
	    	    	    	},{
	    	    	    		columnField:'该员工与华为为何种关系',
	    	    	    		columnKey:'relatedForHw',
	    	    	    		placeholder:'现职员工，离职员工',
	    	    	    		valid:{
	    	    	    			maxLength:255,
	    	    	    			required:{
	    	    	    				value:true,
	    	    	    				tipMsg:""
	    	    	    			}
	    	    	    		},
	    	    	    		columnWidth:'20%'
	    	    	    	},{
	    	    	    		columnField:'该员工与贵司为何种关系',
	    	    	    		columnKey:'relatedForOther',
	    	    	    		placeholder:'当前职务',
	    	    	    		valid:{
	    	    	    			maxLength:255,
	    	    	    			required:{
	    	    	    				value:true,
	    	    	    				tipMsg:""
	    	    	    			}
	    	    	    		},
	    	    	    		columnWidth:'20%'
	    	    	    	},{
	    	    	    		columnField:'补充说明',
	    	    	    		columnKey:'relatedExt',
	    	    	    		placeholder:'',
	    	    	    		valid:{
	    	    	    			maxLength:1024,
	    	    	    			required:{
	    	    	    				value:false,
	    	    	    				tipMsg:""
	    	    	    			}
	    	    	    		},
	    	    	    		columnWidth:'20%'
	    	    	    	}],	
	    	    	    	gridRows:[],
	    	    	    	addTag:{
	    	    	    		addText: "增加关联信息",
	    	            		addTipMsg : "最多添加100个关联信息"
	    	    	    	},
	    	    	    	isInput:true,
	    	    	    	choiseAnswers:[],
	    	    	    	signStatus:2,
	    	    	    	isSignStatus:false,
	    	    	    	oldChoiseAnswers:[],
	    	    	    	queationnaireSubjects:systemParaConf.queationnaireSubject
	    			};
	            	
	            	init();
	            	function init(){
	            		OpenUp.queryQuestionnaire().then(function(data){
	            			if(data.answerForQuestionnaire){
	            				if(data.answerForQuestionnaire.huaweiEmployees){
	            					Model.gridRows = JSON.parse(data.answerForQuestionnaire.huaweiEmployees);
	            				}
	            				Model.signStatus = data.answerForQuestionnaire.signStatus;
	            				if(Model.signStatus == 1){
	            					Model.isInput = false;
	            					Model.isSignStatus = true;
	            					Model.choiseAnswers = data.answerForQuestionnaire.choiseAnswers?data.answerForQuestionnaire.choiseAnswers.split(','):[];
	            					Model.oldChoiseAnswers = angular.copy(Model.choiseAnswers);
	            				}else{
	            					Model.isInput = true;
	            				}
	            			}else{
	            				Model.isInput = true;
	            			}
	            		});
	            	}
	            	
	            	Model.changeSignStatus = function(){
	            		if(Model.isInput){
	            			Model.isSignStatus = !Model.isSignStatus;
	            		}
	            	};
	            	
	            	Model.doSubmit = function(){
	            		if(!((Model.choiseAnswers.indexOf('A') >= 0 || Model.choiseAnswers.length>0 && Model.choiseAnswers.indexOf('A') == -1 && Model.gridRows.length > 0 && $scope.questionnaireForm.$valid) && Model.isSignStatus)){
	            			return;
	            		}
	            		var answerForQuestionnaire = {
	            			choiseAnswers:Model.choiseAnswers.join(','),
	            			signStatus:1
	            		};
	            		if(Model.choiseAnswers.length>0 && Model.choiseAnswers.indexOf('A') == -1 && Model.gridRows && Model.gridRows.length>0){
	            			answerForQuestionnaire.huaweiEmployees = JSON.stringify(Model.gridRows);
	            		}
	            		var param = {
                    			req:{
                    				answerForQuestionnaire:answerForQuestionnaire
                    			}
                    	}
	            		if(Model.oldChoiseAnswers.length>0 && Model.oldChoiseAnswers.indexOf('A') == -1 && Model.choiseAnswers.indexOf('A') >= 0){
	            			auiDialog.confirm("是否更改为无关联关系？", "更改为无关联关系，您将删除所有已反馈的关联信息。", function () {
	            				fillQuestionnaire(param);
                            }, function () {
                               
                            });
	            		}else{
	            			fillQuestionnaire(param);
	            		}
	            	};
	            	
	            	function fillQuestionnaire(param){
	            		var defer = $q.defer();
	            		OpenUp.fillQuestionnaire(param).then(function(data){
                    		if(data.resultCode == 0){
                    			$state.go('mysetting.modUserInfoCorp',{quetionnareLable:"1"});
                    		}
                    		defer.resolve();
                    	}).catch(function(){
                    		defer.reject();
                    	});
	            	}
	            	
	            	Model.cancel = function(){
	            		if(Model.oldChoiseAnswers == 0){
	            			$state.go('mysetting.modUserInfoCorp', {quetionnareLable:"1"});
	            		}else{
	            			init();
	            		}
	            		
	            	};
	            	
	            	Model.back = function(){
	            		$state.go('mysetting.modUserInfoCorp',{quetionnareLable:"1"});
	            	};
	            	
	            	Model.toDoEdit = function(){
	            		Model.isInput = true;
	            	};
	            	
	            	Model.selectChoiseAnswers = function(value){
	            		if (Model.choiseAnswers) {
	                        if (AUI.BaseJSUtil.contains(Model.choiseAnswers, value)) {
	                            AUI.BaseJSUtil.arrayRemove(Model.choiseAnswers, value);
	                        } else {
	                            Model.choiseAnswers.push(value)
	                            if(value == 'A'){
	                            	for(var i=1;i<Model.queationnaireSubjects.length;i++){
	                            		AUI.BaseJSUtil.arrayRemove(Model.choiseAnswers, Model.queationnaireSubjects[i].key);
	                            	}
	                            }else{
	                            	AUI.BaseJSUtil.arrayRemove(Model.choiseAnswers, 'A');
	                            }
	                        }
	                        
	                    }
	            	};
	            	
	            	
        }]);
});

